import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { environment } from '../../../../environments/environment';
import { FileUpload } from 'primeng/fileupload';
import { Table } from 'primeng/table';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';

@Component({
  selector: 'app-technical-negotiations',
  standalone: false,
  templateUrl: './technical-negotiations.component.html',
  styleUrl: './technical-negotiations.component.scss'
})
export class TechnicalNegotiationsComponent implements OnInit, AfterViewInit {
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() step: any;
  @Input() id: any
  @Input() getUrl: any
  @Input() postUrl: any
  @Input() schemeType: any
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  tncForm: FormGroup;
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @ViewChild('table') table: Table;
  payload: {
    proposal_id: any;
    // proposal_step:proposalStep,
    proposal_name: any;
  };
  tncData: any;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedUrl: any;
  apiUrl = environment.APIUrl
  vendors: any;
  JustificationForm: FormGroup;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  resId: any
  userID: any;
  userRoleCode: string = '';

  // R-TN specific fields
  meeting_date: string = '';
  meeting_time: string = '';
  meeting_venue: string = '';

  // Selected committee (readonly) – used when schemeType is 'rev'
  committees: any[] = [];

  // Firm capacity required flag
  firmCapacityRequired: string = 'yes';

  constructor(private messageService: MessageService, private fb: FormBuilder, private api: ApiService, private route: ActivatedRoute) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
    this.userRoleCode = sessionStorage.getItem('user_role_code') || '';
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName
      }
      this.tncForm = this.fb.group({
        tnc: ['']
      })
      this.JustificationForm = this.fb.group({
        comment: [''],
      });
      this.getStep();
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.JustificationForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.JustificationForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
 getStep() {
  let baseUrl: string;

  if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
    baseUrl = '/make1/technical-negotiation/';
  } else if (this.schemeType === 'idex') {
    baseUrl = '/idex/technical-evaluation/';
  } else {
    baseUrl = '/revenue/technical-negotiation/';
  }

  const url = `${baseUrl}?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`;

  this.api.getAPI(url).subscribe((res: any) => {

    // ✅ Store MAIN ID (IMPORTANT for submit)
    this.resId = res?.id;

    // ✅ File
    this.uploadedUrl = res?.tec_report || null;

    // ✅ Justification
    this.JustificationForm.patchValue({
      comment: res?.justification || ''
    });

    // ✅ Meeting Details
    this.meeting_date = res?.meeting_date || '';
    this.meeting_time = res?.meeting_time || '';
    this.meeting_venue = res?.meeting_venue || '';
    this.firmCapacityRequired = res?.step_capacity || 'yes';

    // ✅ Reset vendors
    this.vendors = [];

    // ✅ Safe iteration
    if (res?.vendors) {
      Object.keys(res.vendors).forEach((vendorName: string) => {

        const vendorEntries = res.vendors[vendorName];

        vendorEntries.forEach((entry: any) => {

          // ❌ Skip null vendor
          if (!entry?.vendor) return;

          this.vendors.push({
            id: entry.id,
            vendor: entry.vendor,
            file: entry.file,
            status: entry.vendor_status,
            date: entry.meeting_date,
            time: entry.meeting_time,
            venue: entry.meeting_venue,
            firm_representatives: entry.firm_representatives || '',
            technical_negotiation: entry.technical_negotiation || entry.technical_negotiation || null,
            uploadedFile: null
          });

        });

      });
    }

    // ✅ Optional: REV flow
    if (this.schemeType === 'rev' && this.payload?.proposal_id) {
      this.getCommittees();
    }

    // 🔥 Debug (optional)
    // console.log('Final Vendors:', this.vendors);
  });
}

  getCommittees(): void {
    this.api.getAPI(`/transaction/committee/?proposal=${this.payload.proposal_id}`).subscribe((res: any) => {
      if (res && Array.isArray(res) && res.length > 0) {
        this.committees = res.map((committee: any) => ({
          ...committee,
          members: (committee.members || []).map((member: any, index: number) => ({
            ...member,
            slNo: index + 1,
            user: member.user_name || member.user || ''
          }))
        }));
      } else {
        this.committees = [];
      }
    });
  }

  uploadedFileName: string = '';
  file: File;
  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }

  isHeaderAdd: boolean = false;
  headerName: string = '';
  tecData: any[] = [];
  tecDataHeader: any[] = [];

  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 35 ? fileName.substring(0, 35) + '...' : fileName;
  }
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    this.uploadedUrl = null;
    fileUpload.clear();
  }

  onRowEditInit(rowData: any) {
    //console.log(rowData)
    // Optional: Store a copy of original row if needed
    rowData.originalData = { ...rowData };
  }

onRowEditSave(rowData: any) {

  let url: string;

  if (this.schemeType === 'idex') {
    url = `/idex/technical-evaluation/`;
  } else {
    url = ['makeI', 'makeII', 'makeIII'].includes(this.schemeType)
      ? '/make1/technical-negotiation/'
      : '/revenue/technical-negotiation/';
  }

  const formData = new FormData();

  // ✅ IDEX PAYLOAD
  if (this.schemeType === 'idex') {

    formData.append('vendor_eval_id', rowData.id); // ✅ IMPORTANT
    formData.append('vendor_status', rowData.status);

    formData.append('date', rowData.date || '');
    formData.append('time', rowData.time || '');
    formData.append('venue', rowData.venue || '');
    formData.append('representative', rowData.firm_representatives || '');

  } else {

    // ✅ OLD FLOW (Make / Revenue)
    formData.append('proposal_step', this.step.id);
    formData.append('vendor_id', rowData.id);
    formData.append('vendor_status', rowData.status);

    formData.append('meeting_date', rowData.date || '');
    formData.append('meeting_time', rowData.time || '');
    formData.append('meeting_venue', rowData.venue || '');
    formData.append('firm_representatives', rowData.firm_representatives || '');

    formData.append('step_capacity', this.firmCapacityRequired);
  }

  // ✅ FILE (common)
  if (rowData.uploadedFile) {
    formData.append('file', rowData.uploadedFile);
  }

  // ✅ API CALL
  this.api.putAPI(url, formData).subscribe((res: any) => {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Vendor updated successfully'
    });

    this.table.cancelRowEdit(rowData);
    this.getStep();
  });
}

  onRowEditCancel(rowData: any, index: number) {
    // Revert to original data
    if (rowData.originalData) {
      this.vendors[index] = { ...rowData.originalData };
    }
  }
  onFileUpload(event: any, rowData: any): void {
    const file = event.target.files[0];
    if (file) {
      rowData.uploadedFile = file;
      rowData.uploadedFileName = file.name;
      // Optional: Upload to server here or store temporarily
      //console.log('File selected:', file.name);
    }
  }
onSubmit() {
  
  const justification = this.JustificationForm.get('comment')?.value;

  const formData = new FormData();

  // ✅ IDEX FLOW
  if (this.schemeType === 'idex') {

    formData.append('id', this.resId); // ✅ IMPORTANT (id: 17)
    formData.append('justification', justification || '');

    this.api.putAPI(`/idex/technical-evaluation/`, formData).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Justification submitted'
        });

        this.getStep();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to submit justification'
        });
      }
    });

  } else {

    // ✅ OLD FLOW (rev / makeI / makeII / makeIII)
    if (this.file) {
      formData.append('tec_report', this.file);
    } else {
      formData.append('justification', justification || '');
    }

    const baseUrl = ['makeI', 'makeII', 'makeIII'].includes(this.schemeType)
      ? '/make1/technical-negotiation/'
      : '/revenue/technical-negotiation/';

    this.api.putAPI(`${baseUrl}${this.resId}/`, formData).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Justification submitted`
        });

        this.fileUpload.clear();
        this.uploadedFileName = '';
        this.getStep();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Failed to submit justification`
        });
      }
    });
  }
}
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.JustificationForm.get('comment')?.value },

      ]
    };
    this.generatePDFEmitter.emit(payload);
  }

  // Update R-TN specific fields
  updateTnFields() {
    const formData = new FormData();
    // Use the id from API response
    if (this.resId) {
      formData.append('id', this.resId.toString());
    }
    formData.append('meeting_date', this.meeting_date || '');
    formData.append('meeting_time', this.meeting_time || '');
    formData.append('meeting_venue', this.meeting_venue || '');
    formData.append('step_capacity', this.firmCapacityRequired);

    const baseUrl = ['makeI', 'makeII', 'makeIII'].includes(this.schemeType)
      ? '/make1/technical-negotiation/'
      : '/revenue/technical-negotiation/';

    this.api.putAPI(`${baseUrl}${this.resId}/`, formData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Meeting details updated successfully',
        });
        this.getStep(); // refresh the data
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update meeting details',
        });
      },
    });
  }

  // Check if current step is R-TN
  get isRtnUser(): boolean {
    // Check if step code is R-TN
    const stepCode = this.stepDetails?.code;
    const isStepRtn = stepCode === 'R-TN';
    const isUserRtn = this.userRoleCode === 'R-TN';
    // Show if step code is R-TN or user role is R-TN
    return isStepRtn || isUserRtn;
  }


}
